module.exports = __webpack_public_path__ + "img/fur-coloured-white-txt.46f1d58b.svg";